<div id="abweichenderOrtGeschaeftsleitungAngaben">

  <div class="mb-5x pt-1">
    <div class="d-flex justify-content-between mb-3x">
      <h2>{{ 'COMMON_UI.FRAGEBOGEN.ABWEICHENDERORTGESCHAEFTSLEITUNG.TITEL' | translate }}</h2>
      <common-ui-daten-uebernahme (picked)="onAbweichenderOrtPicked($event)"
        [itemTemplate]="datenuebernahmeAbweichenderOrtGeschaeftsleitung"
        [items]="stammdaten?.unternehmen?.abweichenderOrtGeschaeftsleitung" [readonly]="readonly"
        context="AbweichenderOrtGeschaeftsleitung"></common-ui-daten-uebernahme>
    </div>
    <div class="form-check">
      <input (change)="onErfassenChanged()" [(ngModel)]="erfassen" [disabled]="readonly" class="form-check-input"
        id="abweichendenOrtErfassen" type="checkbox">
      <label class="form-check-label" for="abweichendenOrtErfassen">
        {{ 'COMMON_UI.FRAGEBOGEN.ABWEICHENDERORTGESCHAEFTSLEITUNG.ERFASSEN' | translate }}
      </label>
    </div>
  </div>
  <div *ngIf="erfassen">
    <div class="mb-5x">
      <h2 class="mb-3x">
        {{ 'COMMON_UI.FRAGEBOGEN.ABWEICHENDERORTGESCHAEFTSLEITUNG.ADRESSE_TITEL' | translate }}
      </h2>
      <ng-container *ngIf="appEnum === 'Fragebogen_EUn'">
        <common-ui-adresserfassung
                [(entsprichtWohnanschrift)]="data.entsprichtWohnanschrift"
                [entsprichtWohnanschriftLabel]="entsprichtWohnanschriftLabel"
                [(auslandsadresse)]="data.auslandsadresse"
                [(inlandsadresse)]="data.inlandsadresse"
                [readonly]="readonly" disablePostfachadresse="true" singleMode="true">
        </common-ui-adresserfassung>
      </ng-container>
      <ng-container *ngIf="appEnum !== 'Fragebogen_EUn'">
        <common-ui-adresserfassung
                [(auslandsadresse)]="data.auslandsadresse"
                [(inlandsadresse)]="data.inlandsadresse"
                [readonly]="readonly" disablePostfachadresse="true" singleMode="true">
        </common-ui-adresserfassung>
      </ng-container>
    </div>

    <div *ngIf="kommunikationsmittelSichtbar">
      <div class="mb-5x">
        <h2 class="mb-3x">
          {{ 'COMMON_UI.FRAGEBOGEN.ABWEICHENDERORTGESCHAEFTSLEITUNG.KOMMUNIKATIONSMITTEL_TITEL' | translate }}
        </h2>
        <common-ui-kommunikationsmittel [(data)]="data.kommunikationsmittel" [readonly]="readonly"
          [stammdatenTelefonnummern]="stammdaten?.unternehmen?.abweichenderOrtGeschaeftsleitung?.kommunikationsmittel?.telefonnummern"
          [stammdatenInternetadressen]="stammdaten?.unternehmen?.abweichenderOrtGeschaeftsleitung?.kommunikationsmittel?.internet"
          maxTelefonnummern="2">
        </common-ui-kommunikationsmittel>
      </div>
    </div>
  </div>
</div>

<ng-template #datenuebernahmeAbweichenderOrtGeschaeftsleitung let-item="item">
  <h4 class="list-group-item-heading">
    <div *ngIf="item?.inlandsadresse">
      {{item?.inlandsadresse.strasse}} {{item?.inlandsadresse.hausnummer}} {{item?.inlandsadresse.hausnummernzusatz}}
      <br *ngIf="item?.inlandsadresse.adressergaenzung">{{item?.inlandsadresse.adressergaenzung}}
      <br>{{item?.inlandsadresse.postleitzahl}} {{item?.inlandsadresse.ort}}
    </div>
    <div *ngIf="item?.auslandsadresse">
      {{item?.auslandsadresse.strasse}} {{item?.auslandsadresse.hausnummer}} {{item?.auslandsadresse.hausnummernzusatz}}
      <br *ngIf="item?.auslandsadresse.adressergaenzung">{{item?.auslandsadresse.adressergaenzung}}
      <br>{{item?.auslandsadresse.postleitzahl}} {{item?.auslandsadresse.ort}}
      <br>{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.LAND.KEY_' + item?.auslandsadresse.land | translate }}
    </div>
      <div *ngIf="kommunikationsmittelSichtbar &&
              item?.kommunikationsmittel?.telefonnummern &&
              item.kommunikationsmittel.telefonnummern.length > 0">
        <br>
        Tel.: {{item.kommunikationsmittel.telefonnummern[0].vorwahlInternational}}
        {{item.kommunikationsmittel.telefonnummern[0].vorwahlNational}}
        {{item.kommunikationsmittel.telefonnummern[0].rufnummer}}
      </div>
  </h4>
</ng-template>
